import React, { createContext, useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
const Context = createContext([]);
export function ListProvider({ children }) {
    const [lists, setLists] = useState({});
    const { pathname: path } = useLocation();
    useEffect(() => {
        const ids = Object.keys(lists || {});
        if (ids.length === 0)
            return;
        for (const id of ids) {
            const list = lists[id];
            const list_path = (list === null || list === void 0 ? void 0 : list.path) || '';
            if (path.indexOf(list_path) === -1) {
                delete lists[id];
            }
        }
        setLists(Object.assign({}, lists));
    }, [path]);
    return (React.createElement(Context.Provider, { value: [lists, setLists] }, children));
}
export function useListContext() {
    return useContext(Context);
}
